<template>
  <form-section :title="$t('NotificationLog_Interactions')">
    <rest-list :payload="fetchEndpoint" :outline="false">
      <rest-list-column
        prop="profile_id"
        :title="$t('NotificationLog_Interaction_Profile')"
        :route="$can('UserData::ReadAccess') ? profileIdRoute : null"
        :width="300"
      />

      <rest-list-column
        v-if="showDeviceId"
        prop="device_id"
        :title="$t('NotificationLog_Interaction_Device')"
        :route="$can('Device::Read') ? deviceIdRoute : null"
        :width="180"
      />

      <rest-list-column-enum
        :title="$t('NotificationLog_Interaction_Act')"
        :enum="actionOptions"
        prop="act"
        :width="180"
      />

      <rest-list-column
        v-if="showButton"
        prop="button"
        :title="$t('NotificationLog_Interaction_Button')"
      />

      <rest-list-column
        v-if="showLinkUrl"
        prop="link_url"
        :title="$t('NotificationLog_Interaction_LinkUrl')"
      />

      <rest-list-column-date
        prop="create_time"
        :title="$t('NotificationLog_Interaction_Date')"
        :width="180"
      />
    </rest-list>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'

export default {
  name: 'NotificationInteractions',

  components: {
    FormSection,
    RestList,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnDate
  },

  props: {
    model: {
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `actions/${this.$route.query.id}/acts`,
        params: { expand: 'link_url' }
      })
    },

    showDeviceId() {
      return !(
        this.model.message_type === MessageTypeEnum.EMAIL ||
        this.model.message_type === MessageTypeEnum.SMS ||
        this.model.message_type === MessageTypeEnum.WHATSAPP ||
        (this.model.message_type === MessageTypeEnum.INBOX &&
          this.features.inboxProfileOn)
      )
    },

    showButton() {
      return !(
        this.model.message_type === MessageTypeEnum.EMAIL ||
        this.model.message_type === MessageTypeEnum.SMS ||
        this.model.message_type === MessageTypeEnum.WHATSAPP ||
        this.model.message_type === MessageTypeEnum.WEBHOOK
      )
    },

    showLinkUrl() {
      return this.model.message_type === MessageTypeEnum.EMAIL
    },

    actionOptions() {
      return {
        open: this.$t('NotificationLog_Interaction_Open'),
        click: this.$t('NotificationLog_Interaction_Click'),
        close: this.$t('NotificationLog_Interaction_Close')
      }
    },
    features() {
      return this.$store.state.app.features
    }
  },

  methods: {
    profileIdRoute(row) {
      return projectRoute({
        name: 'ProfileOverview',
        query: {
          profile_id: row.profile_id
        }
      })
    },

    deviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: { device_id: row.device_id }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/NotificationInteractions.vue